// extracted by css-extract-rspack-plugin
export default {"wrapper":"WithAdditional-module__wrapper--Y0bKv","text-overflow":"WithAdditional-module__text-overflow--uxzJn","textOverflow":"WithAdditional-module__text-overflow--uxzJn"};